<script setup lang="ts">
import type { LocationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  location: LocationCollectionItem
}>()

const {
  isActive,
  location,
  toggle,
  address,
  companyName,
} = useLocation(props.location)
</script>

<template>
  <div
    class="cursor-pointer select-none group"
    :class="{
      'dark:bg-neutral-800 dark:hover:bg-neutral-900 bg-neutral-50 hover:bg-primary-200': !isActive,
      'dark:bg-primary-800 dark:hover:bg-primary-900 bg-primary-200 hover:bg-primary-300': isActive,
    }" @click="toggle"
  >
    <div
      class="flex px-2 py-1  text-sm"
    >
      <div class="flex gap-2 flex-wrap">
        <span v-if="location.owner" class="font-bold">{{ location.owner }}</span>
        <span v-if="companyName">{{ location.companyName }}</span>
      </div>
      <div class="ml-auto">
        <WelfareBrandChip
          v-if="location.welfareBrandKey"
          :welfare-brand-key="location.welfareBrandKey"
        />
      </div>
    </div>
    <div class="flex flex-wrap gap-2 text-xs px-2 py-1 justify-between items-center">
      <span v-if="address">{{ address }}</span>
      <span v-if="props.location.address.country" class="dark:text-neutral-400">{{ props.location.address.country }}</span>
    </div>
  </div>
</template>
